import { presetsApi } from "../api/presets";

// Saves a kit + pattern zip to the visitor's disk. Shared by the kit page's
// Download button and the catalogue rows, so both name the file the same way
// and release the same resources. Throws the API error for the caller to
// word; the caller also owns the "signed out -> /login" decision.
export async function downloadKit(item) {
  const res = await presetsApi.download(item.id);
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  try {
    a.href = url;
    a.download = `${item.title || "kit"}.zip`;
    document.body.appendChild(a);
    a.click();
  } finally {
    // The anchor and the object URL must be released even if the save
    // itself throws (e.g. the click handler or appendChild fails) -
    // otherwise a failed download also leaks a detached node and a blob
    // URL that never gets revoked.
    a.remove();
    URL.revokeObjectURL(url);
  }
}
